export const AgentBuilder = {
    AGENT_BUILDER_LAUNCHER_VIEWED: 'Agent Builder Launcher Viewed',
    AGENT_BUILDER_VIEWED: 'Agent Builder Viewed',
    NEW_AGENT_CREATED: 'New Agent Created',
    NEW_TAKA_CREATED: 'New Taka Created',
    MANUAL_UPDATE_AGENT_FIELD: 'Manual Update Agent Field',
    AGENT_BUILDER_SKILL_ENABLED: 'Agent Builder Skill Enabled',
    AGENT_BUILDER_SKILL_DISABLED: 'Agent Builder Skill Disabled',
    AGENT_BUILDER_TAB_TAPPED: 'Agent Builder Tab Tapped',
    AUTH_TAPPED: 'Auth Tapped',
    BUILDER_SUGGESTION_TAPPED: 'Builder Suggestion Tapped',
    BUILDER_START_CHAT_TAPPED: 'Builder Start Chat Tapped',
};
export const Agents = {
    TAKA_PROFILE_VIEWED: 'Taka Profile Viewed',
    MY_TAKA_CHAT_TAPPED: 'My Taka Chat Tapped',
    MY_TAKA_EDIT_TAPPED: 'My Taka Edit Tapped',
    ADD_TAKA_TAPPED: 'Add Taka Tapped',
    CREATE_NEW_TAKA_TAPPED: 'Create New Taka Tapped',
    TAKA_STORE_VIEWED: 'Taka Store Viewed',
    TAKA_STORE_TAPPED: 'Taka Store Tapped',
    TAKAS_STORE_CATEGORY_TAPPED: 'Takas Store Category Tapped',
    OPEN_TAKA_CHAT_CLICKED: 'Open Taka Chat Clicked',
};
export const Apps = {
    APP_VIEWED: 'App Viewed',
    APP_INTERACTED: 'App Interacted',
    EMAIL_DRAFT_GENERATED: 'Email Draft Generated',
    EMAIL_DRAFT_EXPORTED: 'Email Draft Exported',
};
export const Application = {
    APP_OPENED: 'App Opened',
    PAGE_VIEWED: 'Page Viewed',
    MOBILE_SIDEBAR_TOGGLED: 'Mobile Sidebar Toggled',
    MOBILE_BLOCK_PAGE_VIEWED: 'Mobile Block Page Viewed',
    MOBILE_BLOCK_PAGE_OPEN_APP_TAPPED: 'Mobile Block Page Open App Tapped',
    MOBILE_BLOCK_PAGE_DOWNLOAD_APP_TAPPED: 'Mobile Block Page Download App Tapped',
    WELCOME_PAGE_VIEWED: 'Welcome Page Viewed',
    WELCOME_PAGE_SCROLLED: 'Welcome Page Scrolled',
};
export const Autopilot = {
    AUTOPILOT_PLAN_OPENED: 'Autopilot Plan Opened',
    AUTOPILOT_PLAN_FIELD_UPDATED: 'Autopilot Plan Field Updated',
    AUTOPILOT_PLAN_CLOSED: 'Autopilot Plan Closed',
    AUTOPILOT_WIZARD_STEP_VIEWED: 'Autopilot Wizard Step Viewed',
    AUTOPILOT_WIZARD_ABANDONED: 'Autopilot Wizard Abandoned',
    AUTOPILOT_DRAFT_TAPPED: 'Autopilot Draft Tapped',
    AUTOPILOT_DRAFTS_VIEWED: 'Autopilot Drafts Viewed',
    AUTOPILOT_STATUS_CHANGED: 'Autopilot Status Changed',
    AUTOPILOT_MODE_CHANGED: 'Autopilot Mode Changed',
    AUTOPILOT_DELETED: 'Autopilot Deleted',
    AUTOPILOT_CREATE_NEW_TAPPED: 'Autopilot Create New Tapped',
    AUTOPILOT_PLAN_CREATED: 'Autopilot Plan Created',
    AUTOPILOT_RESCHEDULE_APPLIED: 'Autopilot Reschedule Applied',
    AUTOPILOT_GENERATION_STARTED: 'Autopilot Generation Started',
    AUTOPILOT_GENERATION_COMPLETED: 'Autopilot Generation Completed',
    AUTOPILOT_CREATIVE_GENERATED: 'Autopilot Creative Generated',
    AUTOPILOT_PUBLISH_ENQUEUED: 'Autopilot Publish Enqueued',
    AUTOPILOT_PUBLISH_COMPLETED: 'Autopilot Publish Completed',
    AUTOPILOT_PUBLISH_FAILED: 'Autopilot Publish Failed',
    WEEKLY_QUEUE_VIEWED: 'Weekly Queue Viewed',
    WEEKLY_ADDPOST_REQUESTED: 'Weekly Add Post Requested',
    WEEKLY_ADDPOST_COMPLETED: 'Weekly Add Post Completed',
    WEEKLY_ADDPOST_FAILED: 'Weekly Add Post Failed',
    WEEKLY_POST_TWEAKED: 'Weekly Post Tweaked',
    WEEKLY_SESSION_COMPLETED: 'Weekly Session Completed',
    WEEKLY_CONNECT_PROMPT_SHOWN: 'Weekly Connect Prompt Shown',
    WEEKLY_CONNECT_PROMPT_CONNECTED: 'Weekly Connect Prompt Connected',
    WEEKLY_CONNECT_PROMPT_DISMISSED: 'Weekly Connect Prompt Dismissed',
    WEEKLY_DAY_SELECTED: 'Weekly Day Selected',
    AUTOPILOT_HORIZON_TOPUP: 'Autopilot Horizon Top Up',
};
export const Authentication = {
    LOGIN_PAGE_VIEWED: 'Login Page Viewed',
    OTP_VERIFICATION_PAGE_VIEWED: 'OTP Verification Page Viewed',
    LOGIN_STARTED: 'Login Started',
    LOGIN_COMPLETED: 'Login Completed',
    LOGIN_FAILED: 'Login Failed',
    LOGOUT: 'Logout',
    EMAIL_LOGIN_BUTTON_CLICKED: 'Email Login Button Clicked',
    OTP_VERIFY_BUTTON_CLICKED: 'OTP Verify Button Clicked',
    RESEND_OTP_BUTTON_CLICKED: 'Resend OTP Button Clicked',
    BACK_TO_EMAIL_BUTTON_CLICKED: 'Back to Email Button Clicked',
    LOGIN_FROM_LANDING_PAGE: 'Login From Landing Page',
    REFRESH_TOKEN_REUSE_DETECTED: 'Refresh Token Reuse Detected',
};
export const Chat = {
    CHAT_CREATED: 'Chat Created',
    CHAT_OPENED: 'Chat Opened',
    CHAT_LEFT: 'Chat Left',
    MESSAGE_SENT: 'Message Sent',
    MESSAGE_RECEIVED: 'Message Received',
    AGENT_MESSAGE_SENT: 'Agent Message Sent',
    AGENT_MESSAGE_RECEIVED: 'Agent Message Received',
    MESSAGE_REACTION_ADDED: 'Message Reaction Added',
    REPLY_TO_MESSAGE_SELECTED: 'Reply to Message Selected',
    CHAT_INPUT_SUGGESTION_TAPPED: 'Chat Input Suggestion Tapped',
    CHAT_INFO_TAPPED: 'Chat Info Tapped',
    CHAT_INFO_ADD_MEMBERS_TAPPED: 'Chat Info Add Members Tapped',
    INVITE_TO_CHAT_TAPPED: 'Invite to Chat Tapped',
    CHAT_JOINED_VIA_LINK: 'Chat Joined via Link',
    CHAT_JOINED_VIA_ADD_USER: 'Chat Joined via Add User',
    CHAT_LAUNCHER_VIEWED: 'Chat Launcher Viewed',
    CHAT_LIST_CHAT_TAPPED: 'Chat List Chat Tapped',
    CHAT_LAUNCHER_CAROUSEL_NEXT: 'Chat Launcher Carousel Next',
    CHAT_LAUNCHER_CAROUSEL_PREVIOUS: 'Chat Launcher Carousel Previous',
    CHAT_LIST_VIEWED: 'Chat List Viewed',
    CONNECTOR_SEEN: 'Connector Seen',
    CONNECTOR_TAPPED: 'Connector Tapped',
    INTEGRATION_CONNECT_SUCCESS: 'Integration Connect Success',
    INTEGRATION_CONNECT_FAILED: 'Integration Connect Failed',
    CONNECTOR_REVOKE_TAPPED: 'Connector Revoke Tapped',
    CONNECTOR_REVOKE_SUCCESS: 'Connector Revoke Success',
    CONNECTOR_REVOKE_FAILED: 'Connector Revoke Failed',
    TASK_SEEN: 'Task Seen',
    TASK_TAPPED: 'Task Tapped',
};
export const Engagement = {
    ENGAGEMENT_1O1M: 'Engagement 1o1m',
    ENGAGEMENT_1O2M: 'Engagement 1o2m',
    ENGAGEMENT_1O3M: 'Engagement 1o3m',
    ENGAGEMENT_2O1M: 'Engagement 2o1m',
    ENGAGEMENT_2O2M: 'Engagement 2o2m',
    ENGAGEMENT_2O3M: 'Engagement 2o3m',
    ENGAGEMENT_3O1M: 'Engagement 3o1m',
    ENGAGEMENT_3O2M: 'Engagement 3o2m',
    ENGAGEMENT_3O3M: 'Engagement 3o3m',
};
export const Errors = {
    ERROR_OCCURRED: 'Error Occurred',
    CSP_VIOLATION_REPORTED: 'CSP Violation Reported',
};
export const Onboarding = {
    ONBOARDING_STARTED: 'Onboarding Started',
    ONBOARDING_COMPLETED: 'Onboarding Completed',
    ONBOARDING_CONVERSATION_VIEWED: 'Onboarding Conversation Viewed',
    ONBOARDING_CONVERSATION_GUIDELINE_CAPTURED: 'Onboarding Conversation Guideline Captured',
    ONBOARDING_PHASE_VIEWED: 'Onboarding Phase Viewed',
    ONBOARDING_SCRAPE_COMPLETED: 'Onboarding Scrape Completed',
    ONBOARDING_BRAND_CARD_SUBMITTED: 'Onboarding Brand Card Submitted',
    ONBOARDING_PRESENCE_SUBMITTED: 'Onboarding Presence Submitted',
    ONBOARDING_VISUALS_SUBMITTED: 'Onboarding Visuals Submitted',
    ONBOARDING_STEP_UPDATE_PROFILE_VIEWED: 'Onboarding Step Update Profile Viewed',
    ONBOARDING_STEP_UPDATE_PROFILE_UPLOADED_PHOTO: 'Onboarding Step Update Profile Uploaded Photo',
    ONBOARDING_STEP_UPDATE_PROFILE_UPDATED_NAME: 'Onboarding Step Update Profile Updated Name',
    ONBOARDING_STEP_BUSINESS_NAME_VIEWED: 'Onboarding Step Business Name Viewed',
    ONBOARDING_STEP_BUSINESS_NAME_SUBMITTED: 'Onboarding Step Business Name Submitted',
    ONBOARDING_STEP_WEBSITE_URL_VIEWED: 'Onboarding Step Website URL Viewed',
    ONBOARDING_STEP_WEBSITE_URL_SUBMITTED: 'Onboarding Step Website URL Submitted',
    ONBOARDING_STEP_WEBSITE_URL_SKIPPED: 'Onboarding Step Website URL Skipped',
    ONBOARDING_STEP_BUSINESS_PROFILE_VIEWED: 'Onboarding Step Business Profile Viewed',
    ONBOARDING_STEP_ANALYZING_WEBSITE_VIEWED: 'Onboarding Step Analyzing Website Viewed',
    ONBOARDING_STEP_ANALYZING_WEBSITE_COMPLETED: 'Onboarding Step Analyzing Website Completed',
    ONBOARDING_STEP_INDUSTRY_VIEWED: 'Onboarding Step Industry Viewed',
    ONBOARDING_STEP_INDUSTRY_SUBMITTED: 'Onboarding Step Industry Submitted',
    ONBOARDING_STEP_DESCRIPTION_VIEWED: 'Onboarding Step Description Viewed',
    ONBOARDING_STEP_DESCRIPTION_SUBMITTED: 'Onboarding Step Description Submitted',
    ONBOARDING_STEP_TARGET_AUDIENCE_VIEWED: 'Onboarding Step Target Audience Viewed',
    ONBOARDING_STEP_TARGET_AUDIENCE_SUBMITTED: 'Onboarding Step Target Audience Submitted',
    ONBOARDING_STEP_LOGO_VIEWED: 'Onboarding Step Logo Viewed',
    ONBOARDING_STEP_LOGO_SUBMITTED: 'Onboarding Step Logo Submitted',
    ONBOARDING_STEP_BRAND_COLORS_VIEWED: 'Onboarding Step Brand Colors Viewed',
    ONBOARDING_STEP_BRAND_COLORS_SUBMITTED: 'Onboarding Step Brand Colors Submitted',
    ONBOARDING_STEP_BRAND_FONTS_VIEWED: 'Onboarding Step Brand Fonts Viewed',
    ONBOARDING_STEP_BRAND_FONTS_SUBMITTED: 'Onboarding Step Brand Fonts Submitted',
    ONBOARDING_STEP_BRAND_IDENTITY_VIEWED: 'Onboarding Step Brand Identity Viewed',
    ONBOARDING_STEP_BRAND_IDENTITY_SUBMITTED: 'Onboarding Step Brand Identity Submitted',
    ONBOARDING_STEP_BRAND_IDENTITY_SKIPPED: 'Onboarding Step Brand Identity Skipped',
    ONBOARDING_STEP_BRAND_IMAGES_VIEWED: 'Onboarding Step Brand Images Viewed',
    ONBOARDING_STEP_BRAND_IMAGES_SUBMITTED: 'Onboarding Step Brand Images Submitted',
    ONBOARDING_STEP_BRAND_IMAGES_SKIPPED: 'Onboarding Step Brand Images Skipped',
    ONBOARDING_STEP_SOCIAL_HANDLES_VIEWED: 'Onboarding Step Social Handles Viewed',
    ONBOARDING_STEP_SOCIAL_HANDLES_SUBMITTED: 'Onboarding Step Social Handles Submitted',
    ONBOARDING_STEP_INSTAGRAM_CONNECT_VIEWED: 'Onboarding Step Instagram Connect Viewed',
    ONBOARDING_STEP_INSTAGRAM_CONNECT_SUBMITTED: 'Onboarding Step Instagram Connect Submitted',
    ONBOARDING_STEP_INSTAGRAM_CONNECT_SKIPPED: 'Onboarding Step Instagram Connect Skipped',
    ONBOARDING_STEP_INSTAGRAM_GOALS_VIEWED: 'Onboarding Step Instagram Goals Viewed',
    ONBOARDING_STEP_INSTAGRAM_GOALS_SUBMITTED: 'Onboarding Step Instagram Goals Submitted',
    ONBOARDING_STEP_GOALS_VIEWED: 'Onboarding Step Goals Viewed',
    ONBOARDING_STEP_GOALS_SUBMITTED: 'Onboarding Step Goals Submitted',
    ONBOARDING_STEP_TONE_OF_VOICE_VIEWED: 'Onboarding Step Tone of Voice Viewed',
    ONBOARDING_STEP_TONE_OF_VOICE_SUBMITTED: 'Onboarding Step Tone of Voice Submitted',
    ONBOARDING_STEP_COMPLETE_VIEWED: 'Onboarding Step Complete Viewed',
    ONBOARDING_STEP_USE_CASE_VIEWED: 'Onboarding Step Use Case Viewed',
    ONBOARDING_STEP_USE_CASE_SELECTED: 'Onboarding Step Use Case Selected',
    ONBOARDING_STEP_USE_CASE_CONTINUED: 'Onboarding Step Use Case Continued',
    ONBOARDING_STEP_SELECT_TAKAS_VIEWED: 'Onboarding Step Select Takas Viewed',
    ONBOARDING_STEP_SELECT_TAKAS_ADD: 'Onboarding Step Select Takas Add',
    ONBOARDING_STEP_SELECT_TAKAS_REMOVE: 'Onboarding Step Select Takas Remove',
    ONBOARDING_STEP_SELECT_TAKAS_COMPLETED: 'Onboarding Step Select Takas Completed',
    AGENT_TEMPLATE_INFO_VIEWED: 'Agent Template Info Viewed',
    ONBOARDING_SKIP_FAILED: 'Onboarding Skip Failed',
    BUSINESS_CREATE_REQUESTED: 'Business Create Requested',
    BUSINESS_CREATE_SUCCEEDED: 'Business Create Succeeded',
    BUSINESS_CREATE_FAILED: 'Business Create Failed',
};
export const Profile = {
    NAME_UPDATED: 'Name Updated',
    AVATAR_UPDATED: 'Avatar Updated',
    DELETE_ACCOUNT_REQUESTED: 'Delete Account Requested',
    ACCOUNT_DELETED: 'Account Deleted',
};
export const Paywall = {
    PAYWALL_VIEWED: 'Paywall Viewed',
    PAYWALL_DISMISSED: 'Paywall Dismissed',
    PAYWALL_SKIPPED: 'Paywall Skipped',
    TRIAL_TIMELINE_VIEWED: 'Trial Timeline Viewed',
    PAYWALL_INFO_CTA_CLICKED: 'Paywall Info CTA Clicked',
    TRIAL_CHECKOUT_CTA_CLICKED: 'Trial Checkout CTA Clicked',
    PAYWALL_UPGRADE_CTA_CLICKED: 'Paywall Upgrade CTA Clicked',
    CHECKOUT_STARTED: 'Checkout Started',
    CHECKOUT_COMPLETED: 'Checkout Completed',
    PROMO_CODE_REDEEMED: 'Promo Code Redeemed',
    PROMO_CODE_APPLIED: 'Promo Code Applied',
    PROMO_CODE_REMOVED: 'Promo Code Removed',
    PROMO_CODE_FAILED: 'Promo Code Failed',
    CHECKOUT_FAILED: 'Checkout Failed',
    TRY_PRO_PAGE_VIEWED: 'Try Pro Page Viewed',
    TRY_PRO_DISMISSED: 'Try Pro Dismissed',
    TRY_PRO_TAPPED: 'Try Pro Tapped',
    SKIP_TAPPED: 'Skip Tapped',
};
export const AgentActivation = {
    AGENT_ACTIVATION_STARTED: 'Agent Activation Started',
    AGENT_ACTIVATION_STEP_STARTED: 'Agent Activation Step Started',
    AGENT_ACTIVATION_STEP_COMPLETED: 'Agent Activation Step Completed',
    AGENT_ACTIVATION_STEP_SKIPPED: 'Agent Activation Step Skipped',
    AGENT_ACTIVATION_STEP_FAILED: 'Agent Activation Step Failed',
    AGENT_ACTIVATION_COMPLETED: 'Agent Activation Completed',
    AGENT_ACTIVATION_CANCELLED: 'Agent Activation Cancelled',
};
export const Social = {
    SOCIAL_PUBLISH_TAPPED: 'Social Publish Tapped',
    SOCIAL_PUBLISH_TRIGGERED: 'Social Publish Triggered',
    SOCIAL_PUBLISH_SUCCESS: 'Social Publish Success',
    SOCIAL_PUBLISH_FAILED: 'Social Publish Failed',
    SOCIAL_CONNECT_DIALOG_VIEWED: 'Social Connect Dialog Viewed',
    SOCIAL_CONNECT_DIALOG_DISMISSED: 'Social Connect Dialog Dismissed',
    SOCIAL_COMING_SOON_VIEWED: 'Social Coming Soon Viewed',
    SOCIAL_CONNECT_INITIATED: 'Social Connect Initiated',
    SOCIAL_CONNECT_SUCCEEDED: 'Social Connect Succeeded',
    SOCIAL_CONNECT_FAILED: 'Social Connect Failed',
    SOCIAL_OAUTH_INITIATED: 'Social OAuth Initiated',
    SOCIAL_OAUTH_INITIATED_BLOCKED: 'Social OAuth Initiated Blocked',
    SOCIAL_OAUTH_POPUP_CLOSED: 'Social OAuth Popup Closed',
    SOCIAL_OAUTH_CALLBACK_SUCCESS: 'Social OAuth Callback Success',
    SOCIAL_OAUTH_CALLBACK_FAILED: 'Social OAuth Callback Failed',
    SOCIAL_OAUTH_ACCOUNT_CONFIRMED: 'Social OAuth Account Confirmed',
    SOCIAL_OAUTH_ACCOUNT_SWITCH_REQUESTED: 'Social OAuth Account Switch Requested',
    SOCIAL_TOKEN_REFRESHED: 'Social Token Refreshed',
    SOCIAL_TOKEN_REFRESH_FAILED: 'Social Token Refresh Failed',
    SOCIAL_OAUTH_CALLBACK_RECEIVED: 'Social OAuth Callback Received',
    SOCIAL_TARGETS_LISTED: 'Social Targets Listed',
    SOCIAL_TARGET_SELECTED: 'Social Target Selected',
    FALLBACK_CONNECT_STARTED: 'Fallback Connect Started',
    FALLBACK_CONNECT_SUCCEEDED: 'Fallback Connect Succeeded',
    FALLBACK_CONNECT_FAILED: 'Fallback Connect Failed',
    INSTAGRAM_POST_GENERATED: 'Instagram Post Generated',
    YOUTUBE_CREATIVE_CREATED: 'YouTube Creative Created',
};
export const Home = {
    HOME_VIEWED: 'Home Viewed',
    HOME_SUGGESTION_SCROLLED: 'Home Suggestion Scrolled',
    HOME_SUGGESTION_TAPPED: 'Home Suggestion Tapped',
    HOME_SUGGESTION_GENERATION_STARTED: 'Home Suggestion Generation Started',
    HOME_SUGGESTION_GENERATION_COMPLETED: 'Home Suggestion Generation Completed',
    HOME_SUGGESTION_GENERATED: 'Home Suggestion Generated',
    HOME_SUGGESTIONS_LOADED: 'Home Suggestions Loaded',
    HOME_SUGGESTION_REGENERATE_TAPPED: 'Home Suggestion Regenerate Tapped',
    HOME_SUGGESTIONS_EMPTY: 'Home Suggestions Empty',
    HOME_COMING_SOON_CLICKED: 'Home Coming Soon Clicked',
    HOME_ASK_AI_TAPPED: 'Home Ask AI Tapped',
    HOME_PLATFORM_CONNECT_TAPPED: 'Home Platform Connect Tapped',
    HOME_POST_MODAL_OPENED: 'Home Post Modal Opened',
    HOME_POST_MODAL_TAB_SWITCHED: 'Home Post Modal Tab Switched',
    HOME_POST_MODAL_EDIT_TAPPED: 'Home Post Modal Edit Tapped',
    HOME_POST_MODAL_PLATFORM_TOGGLED: 'Home Post Modal Platform Toggled',
    TOPIC_PICKED: 'Topic Picked',
    TOPIC_DISMISSED: 'Topic Dismissed',
    TOPIC_GENERATE_MORE: 'Topic Generate More',
    TOPIC_CREATIVES_READY: 'Topic Creatives Ready',
    HOME_TOPIC_SWITCHER_OPENED: 'Home Topic Switcher Opened',
    HOME_TOPIC_SWITCHER_CLOSED: 'Home Topic Switcher Closed',
    HOME_IDEA_CARD_TAPPED: 'Home Idea Card Tapped',
    HOME_IDEA_CARD_EDIT_TAPPED: 'Home Idea Card Edit Tapped',
    HOME_IDEA_CARD_REGENERATE_TAPPED: 'Home Idea Card Regenerate Tapped',
    HOME_IDEA_LIVE_BUTTON_OPENED: 'Home Idea Live Button Opened',
    HOME_IDEA_RETRY_FAILED_TAPPED: 'Home Idea Retry Failed Tapped',
    HOME_POST_MODAL_CLOSED: 'Home Post Modal Closed',
    HOME_POST_MODAL_OAUTH_GATE_SHOWN: 'Home Post Modal OAuth Gate Shown',
    HOME_POST_MODAL_OAUTH_GATE_RESOLVED: 'Home Post Modal OAuth Gate Resolved',
    HOME_POST_MODAL_SCHEDULE_FAILED: 'Home Post Modal Schedule Failed',
    HOME_POST_MODAL_MODE_SWITCHED: 'Home Post Modal Mode Switched',
    HOME_CHAT_BAR_TAPPED: 'Home Chat Bar Tapped',
    HOME_TOPIC_GENERATION_STARTED: 'Home Topic Generation Started',
    HOME_TOPIC_GENERATION_COMPLETED: 'Home Topic Generation Completed',
    HOME_TOPIC_GENERATION_FAILED: 'Home Topic Generation Failed',
    HOME_POST_GENERATION_STARTED: 'Home Post Generation Started',
    HOME_POST_GENERATION_COMPLETED: 'Home Post Generation Completed',
    HOME_POST_GENERATION_FAILED: 'Home Post Generation Failed',
    HOME_CREATION_INTENT_SUBMITTED: 'Home Creation Intent Submitted',
    HOME_CREATION_INTENT_CREATED: 'Home Creation Intent Created',
    HOME_CREATION_INTENT_FAILED: 'Home Creation Intent Failed',
    HOME_CREATION_CHIP_TAPPED: 'Home Creation Chip Tapped',
    HOME_INGREDIENT_HINTS_SHOWN: 'Home Ingredient Hints Shown',
    HOME_ARRIVAL_VIEWED: 'Home Arrival Viewed',
    HOME_WEEK_FLOOR_TOGGLED: 'Home Week Floor Toggled',
    HOME_ATTENTION_STRIP_CTA_TAPPED: 'Home Attention Strip CTA Tapped',
    HOME_STREAM_VIEWED: 'Home Stream Viewed',
    HOME_STREAM_CARD_TAPPED: 'Home Stream Card Tapped',
};
export const Composer = {
    COMPOSER_VIEWED: 'Composer Viewed',
    COMPOSER_MESSAGE_SENT: 'Composer Message Sent',
    COMPOSER_MESSAGE_RECEIVED: 'Composer Message Received',
    COMPOSER_CONTENT_GENERATED: 'Composer Content Generated',
    COMPOSER_RENAME_SAVED: 'Composer Rename Saved',
    COMPOSER_DUPLICATE_TAPPED: 'Composer Duplicate Tapped',
    COMPOSER_DELETE_TAPPED: 'Composer Delete Tapped',
    COMPOSER_DOWNLOAD_TAPPED: 'Composer Download Tapped',
    COMPOSER_PREVIEW_IMAGE_DOWNLOADED: 'Composer Preview Image Downloaded',
    COMPOSER_PREVIEW_CONTENT_COPIED: 'Composer Preview Content Copied',
    COMPOSER_PREVIEW_CHANGE_REQUESTED: 'Composer Preview Change Requested',
    COMPOSER_IMAGE_UPLOADED: 'Composer Image Uploaded',
    COMPOSER_VIDEO_UPLOAD_STARTED: 'Composer Video Upload Started',
    COMPOSER_VIDEO_UPLOAD_COMPLETED: 'Composer Video Upload Completed',
    COMPOSER_VIDEO_UPLOAD_FAILED: 'Composer Video Upload Failed',
    COMPOSER_EMPTY_RESPONSE: 'Composer Empty Response',
    COMPOSER_BACK_TAPPED: 'Composer Back Tapped',
    COMPOSER_PLATFORM_ADDED: 'Composer Platform Added',
    COMPOSER_PLATFORM_REMOVED: 'Composer Platform Removed',
    COMPOSER_SCHEDULE_CONNECT_PROMPT_SHOWN: 'Composer Schedule Connect Prompt Shown',
    COMPOSER_SCHEDULE_CONNECT_TAPPED: 'Composer Schedule Connect Tapped',
    COMPOSER_SCHEDULE_CONNECT_SKIPPED: 'Composer Schedule Connect Skipped',
    COMPOSER_EDIT_FLUSHED_ON_TEARDOWN: 'Composer Edit Flushed On Teardown',
    COMPOSER_SCHEDULE_FAILED: 'Composer Schedule Failed',
    COMPOSER_EDIT_MODAL_OPENED: 'Composer Edit Modal Opened',
    COMPOSER_EDIT_MODAL_SAVED: 'Composer Edit Modal Saved',
    COMPOSER_EDIT_MODAL_CANCELLED: 'Composer Edit Modal Cancelled',
    COMPOSER_SCORE_EXPLAINER_OPENED: 'Composer Score Explainer Opened',
    COMPOSER_SCORE_EXPLAINER_ACTION_TAPPED: 'Composer Score Explainer Action Tapped',
};
export const BrandKit = {
    BRAND_KIT_VIEWED: 'Brand Kit Viewed',
    BRAND_KIT_FIELD_UPDATED: 'Brand Kit Field Updated',
    BRAND_KIT_LOGO_UPLOADED: 'Brand Kit Logo Uploaded',
    BRAND_KIT_LOGO_REMOVED: 'Brand Kit Logo Removed',
    BRAND_KIT_RESCAN_INITIATED: 'Brand Kit Rescan Initiated',
    BRAND_KIT_RESCAN_COMPLETED: 'Brand Kit Rescan Completed',
    BRAND_IMAGE_UPLOADED: 'Brand Image Uploaded',
    BRAND_IMAGE_REMOVED: 'Brand Image Removed',
    BRAND_IMAGE_TAGS_UPDATED: 'Brand Image Tags Updated',
};
export const Sidebar = {
    SIDEBAR_NAV_TAPPED: 'Sidebar Nav Tapped',
    SIDEBAR_BUSINESS_SWITCHED: 'Sidebar Business Switched',
    SIDEBAR_CREATE_BUSINESS_TAPPED: 'Sidebar Create Business Tapped',
    ADDITIONAL_BUSINESS_STARTED: 'Additional Business Started',
    ADDITIONAL_BUSINESS_CANCELLED: 'Additional Business Cancelled',
    ADDITIONAL_BUSINESS_COMPLETED: 'Additional Business Completed',
};
export const Creatives = {
    CREATIVE_GENERATION_CARD_VIEWED: 'Creative Generation Card Viewed',
    CREATIVE_GENERATION_STATUS_CHANGED: 'Creative Generation Status Changed',
    CREATIVE_GENERATION_CARD_TAPPED: 'Creative Generation Card Tapped',
    SOCIALKIT_GENERATION_OUTCOME: 'SocialKit Generation Outcome',
};
export const Posts = {
    POSTS_PAGE_VIEWED: 'Posts Page Viewed',
    POSTS_FILTER_TAPPED: 'Posts Filter Tapped',
    POST_SCHEDULED: 'Post Scheduled',
    BYO_UPLOAD_OPENED: 'BYO Upload Opened',
    BYO_POST_CREATED: 'BYO Post Created',
    BYO_MEDIA_UPDATED: 'BYO Media Updated',
    POST_MARKED_NEEDS_APPROVAL: 'Post Marked Needs Approval',
    POST_APPROVED: 'Post Approved',
    POST_RESCHEDULED: 'Post Rescheduled',
    POST_UNSCHEDULED: 'Post Unscheduled',
    POST_REGENERATED: 'Post Regenerated',
    POST_DELETED: 'Post Deleted',
};
export const Credits = {
    CREDIT_CONSUMED: 'Credit Consumed',
    CREDITS_LOW: 'Credits Low',
    CREDITS_EXHAUSTED: 'Credits Exhausted',
    CREDITS_EXHAUSTED_UPGRADE_TAPPED: 'Credits Exhausted Upgrade Tapped',
    CREDITS_EXHAUSTED_TOPUP_TAPPED: 'Credits Exhausted Topup Tapped',
};
export const Billing = {
    BILLING_PAGE_VIEWED: 'Billing Page Viewed',
    BILLING_MANAGE_SUBSCRIPTION_TAPPED: 'Billing Manage Subscription Tapped',
    BILLING_UPGRADE_TO_BUSINESS_TAPPED: 'Billing Upgrade To Business Tapped',
    BILLING_CHOOSE_PLAN_TAPPED: 'Billing Choose Plan Tapped',
    TOPUP_MODAL_VIEWED: 'Topup Modal Viewed',
    TOPUP_REFERRAL_NUDGE_CLICKED: 'Topup Referral Nudge Clicked',
    TOPUP_PACK_SELECTED: 'Topup Pack Selected',
    TOPUP_PURCHASE_COMPLETED: 'Topup Purchase Completed',
    TOPUP_PURCHASE_FAILED: 'Topup Purchase Failed',
};
export const Calendar = {
    CALENDAR_VIEWED: 'Calendar Viewed',
    CALENDAR_ENTRY_TAPPED: 'Calendar Entry Tapped',
    CALENDAR_VIEW_CHANGED: 'Calendar View Changed',
    CALENDAR_DATE_NAVIGATED: 'Calendar Date Navigated',
    CALENDAR_AUTOPILOT_SETUP_STARTED: 'Calendar Autopilot Setup Started',
    CALENDAR_PUBLISH_NOW_TAPPED: 'Calendar Publish Now Tapped',
    CALENDAR_UPCOMING_WIDGET_TAPPED: 'Calendar Upcoming Widget Tapped',
    CALENDAR_POST_GENERATION_TRIGGERED: 'Calendar Post Generation Triggered',
    CALENDAR_POST_GENERATION_COMPLETED: 'Calendar Post Generation Completed',
};
export const AssistantChat = {
    ASSISTANT_CHAT_OPENED: 'Assistant Chat Opened',
    ASSISTANT_CHAT_MESSAGE_SENT: 'Assistant Chat Message Sent',
    ASSISTANT_CHAT_MESSAGE_RECEIVED: 'Assistant Chat Message Received',
    ASSISTANT_CHAT_EMPTY_RESPONSE: 'Assistant Chat Empty Response',
    ASSISTANT_CHAT_QUICK_PROMPT_TAPPED: 'Assistant Chat Quick Prompt Tapped',
};
export const CommentAutomation = {
    COMMENT_AUTOMATION_VIEWED: 'Comment Automation Viewed',
    COMMENT_AUTOMATION_EDITOR_OPENED: 'Comment Automation Editor Opened',
    COMMENT_AUTOMATION_SAVED: 'Comment Automation Saved',
    COMMENT_AUTOMATION_STATUS_CHANGED: 'Comment Automation Status Changed',
    COMMENT_AUTOMATION_DELETED: 'Comment Automation Deleted',
    COMMENT_AUTOMATION_UPGRADE_STARTED: 'Comment Automation Upgrade Started',
    COMMENT_AUTOMATION_EXECUTED: 'Comment Automation Executed',
};
export const Referrals = {
    REFERRAL_SHARED: 'Referral Shared',
    REFERRAL_SIGNUP: 'Referral Signup',
    REFERRAL_REWARD_APPROVED: 'Referral Reward Approved',
    REFERRAL_REWARDED: 'Referral Rewarded',
    REFERRAL_CELEBRATION_VIEWED: 'Referral Celebration Viewed',
    REFERRAL_CLAIM_DEFERRED: 'Referral Claim Deferred',
    REFERRAL_REJECTED: 'Referral Rejected',
};
export const Support = {
    SUPPORT_HANDOFF_CREATED: 'Support Handoff Created',
    SUPPORT_HANDOFF_MESSENGER_OPENED: 'Support Handoff Messenger Opened',
};
export const AnalyticsEvents = {
    AgentBuilder,
    Agents,
    Apps,
    Application,
    Autopilot,
    Authentication,
    Chat,
    Engagement,
    Errors,
    Onboarding,
    Profile,
    Paywall,
    AgentActivation,
    Social,
    Home,
    Composer,
    BrandKit,
    Sidebar,
    Creatives,
    Posts,
    Credits,
    Billing,
    Calendar,
    AssistantChat,
    CommentAutomation,
    Referrals,
    Support,
};
export const NewTakaCreatedSource = {
    ONBOARDING: 'onboarding',
    STORE: 'store',
};
export const NewTakaCreatedType = {
    TEMPLATE: 'template',
    CUSTOM: 'custom',
};
export const ManualUpdateAgentFieldFieldType = {
    NAME: 'name',
    DESCRIPTION: 'description',
    INSTRUCTIONS: 'instructions',
    ABILITIES_DESCRIPTION: 'abilitiesDescription',
    CAPTION: 'caption',
    GREETING: 'greeting',
    PROMISE: 'promise',
};
export const AgentBuilderTabTappedTabName = {
    PREVIEW: 'preview',
    PROMPT: 'prompt',
    MEMORY: 'memory',
    SKILLS: 'skills',
    CHANNELS: 'channels',
    ACTIVATION: 'activation',
    SETTINGS: 'settings',
    KNOWLEDGE: 'knowledge',
    STORE: 'store',
    ADMIN: 'admin',
};
export const TakaProfileViewedSource = {
    TAKAS_LIST: 'takas_list',
    CHAT_LAUNCHER: 'chat_launcher',
    CHAT_INFO: 'chat_info',
};
export const MyTakaChatTappedSource = {
    TAKAS_LIST: 'takas_list',
    TAKA_PROFILE: 'taka_profile',
    CHAT_INFO: 'chat_info',
};
export const MyTakaEditTappedSource = {
    TAKAS_LIST: 'takas_list',
    TAKA_PROFILE: 'taka_profile',
    CHAT_INFO: 'chat_info',
};
export const TakasStoreCategoryTappedCategory = {
    _PERSONAL: 'Personal',
    _COLLABORATION: 'Collaboration',
    _WORK: 'Work',
};
export const OpenTakaChatClickedCategory = {
    _PERSONAL: 'Personal',
    _COLLABORATION: 'Collaboration',
    _WORK: 'Work',
};
export const AppInteractedSource = {
    CHAT: 'chat',
    DASHBOARD: 'dashboard',
};
export const AppInteractedAction = {
    MESSAGE_SENT: 'message_sent',
    POST: 'post',
    COPY_EMAIL: 'copy_email',
    SURPRISE_ME: 'surprise_me',
    NEW_IMAGE: 'new_image',
};
export const EmailDraftGeneratedEmailType = {
    PROMOTIONAL: 'promotional',
    NEWSLETTER: 'newsletter',
    ANNOUNCEMENT: 'announcement',
    FOLLOWUP: 'followup',
};
export const EmailDraftExportedExportMethod = {
    COPY_ALL: 'copy_all',
    COPY_SUBJECT: 'copy_subject',
    COPY_BODY: 'copy_body',
};
export const AppOpenedPlatform = {
    WEB: 'web',
    IOS: 'ios',
    ANDROID: 'android',
};
export const PageViewedPageName = {
    HOME: 'home',
    CALENDAR: 'calendar',
    CREATIVES: 'creatives',
    AUTOPILOT: 'autopilot',
    AUTOPILOT_SETUP: 'autopilot_setup',
    COMPOSER: 'composer',
    PROJECT: 'project',
    BRAND: 'brand',
    INTEGRATIONS: 'integrations',
    COLLABORATORS: 'collaborators',
    BILLING: 'billing',
    PROFILE: 'profile',
};
export const PageViewedPlatform = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
};
export const MobileSidebarToggledAction = {
    OPENED: 'opened',
    CLOSED: 'closed',
};
export const MobileBlockPageViewedSource = {
    GENERAL: 'general',
    MOBILE_WEB_SIGNUP: 'mobile-web-signup',
};
export const MobileBlockPageOpenAppTappedPlatform = {
    IOS: 'ios',
    ANDROID: 'android',
    OTHER: 'other',
};
export const MobileBlockPageDownloadAppTappedPlatform = {
    IOS: 'ios',
    ANDROID: 'android',
    OTHER: 'other',
};
export const AutopilotPlanFieldUpdatedField = {
    CHANNEL: 'channel',
    CONTENT_DIRECTION: 'contentDirection',
    CONTENT_SPECIFICS: 'contentSpecifics',
    FREQUENCY: 'frequency',
    PREFERRED_DAY: 'preferredDay',
    PREFERRED_TIME: 'preferredTime',
    STATUS: 'status',
    PUBLISH_MODE: 'publishMode',
};
export const AutopilotWizardStepViewedStep = {
    WHAT: 'what',
    WHEN: 'when',
    HOW: 'how',
    WHERE: 'where',
};
export const AutopilotWizardAbandonedStep = {
    WHAT: 'what',
    WHEN: 'when',
    HOW: 'how',
    WHERE: 'where',
};
export const AutopilotWizardAbandonedReason = {
    CANCEL: 'cancel',
    BACK_OUT: 'back_out',
    UNMOUNT: 'unmount',
};
export const AutopilotDraftTappedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
    TIKTOK_VIDEO: 'tiktok_video',
    LINKEDIN_POST: 'linkedin_post',
};
export const AutopilotDraftTappedPlacement = {
    HOME_DESKTOP: 'home_desktop',
    HOME_MOBILE: 'home_mobile',
    AUTOPILOT_PAGE: 'autopilot_page',
    AUTOPILOT_PAGE_MOBILE: 'autopilot_page_mobile',
};
export const AutopilotStatusChangedFromStatus = {
    ACTIVE: 'active',
    PAUSED: 'paused',
};
export const AutopilotStatusChangedToStatus = {
    ACTIVE: 'active',
    PAUSED: 'paused',
};
export const AutopilotModeChangedFrom = {
    REVIEW: 'review',
    AUTOMATIC: 'automatic',
};
export const AutopilotModeChangedTo = {
    REVIEW: 'review',
    AUTOMATIC: 'automatic',
};
export const AutopilotModeChangedSource = {
    WIZARD: 'wizard',
    SETTINGS: 'settings',
};
export const AutopilotPlanCreatedFrequency = {
    DAILY: 'daily',
    _3X_WEEKLY: '3x_weekly',
    WEEKLY: 'weekly',
    BIWEEKLY: 'biweekly',
    MONTHLY: 'monthly',
};
export const AutopilotPlanCreatedContentDirection = {
    PRODUCTS: 'products',
    EXPERTISE: 'expertise',
    UPDATES: 'updates',
    CUSTOM: 'custom',
};
export const AutopilotPlanCreatedPublishMode = {
    REVIEW: 'review',
    AUTOMATIC: 'automatic',
};
export const AutopilotGenerationStartedContentDirection = {
    PRODUCTS: 'products',
    EXPERTISE: 'expertise',
    UPDATES: 'updates',
    CUSTOM: 'custom',
};
export const AutopilotGenerationStartedPostTypeShape = {
    STATIC: 'static',
    CAROUSEL: 'carousel',
    REEL: 'reel',
};
export const AutopilotCreativeGeneratedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
    TIKTOK_VIDEO: 'tiktok_video',
    LINKEDIN_POST: 'linkedin_post',
};
export const AutopilotCreativeGeneratedStatus = {
    READY: 'ready',
    FAILED: 'failed',
    ERROR: 'error',
};
export const AutopilotPublishEnqueuedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    PINTEREST: 'pinterest',
    TWITTER: 'twitter',
};
export const AutopilotPublishCompletedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    PINTEREST: 'pinterest',
    TWITTER: 'twitter',
};
export const AutopilotPublishFailedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    PINTEREST: 'pinterest',
    TWITTER: 'twitter',
};
export const AutopilotPublishFailedFailureReason = {
    NO_TOKEN: 'no_token',
    NO_MEDIA: 'no_media',
    ALREADY_PUBLISHED: 'already_published',
    CREATIVE_NOT_FOUND: 'creative_not_found',
    API_ERROR: 'api_error',
    UNKNOWN: 'unknown',
};
export const AutopilotPublishFailedSource = {
    CALENDAR: 'calendar',
    ERROR_RETRY: 'error_retry',
};
export const WeeklyQueueViewedPlatform = {
    MOBILE: 'mobile',
    DESKTOP: 'desktop',
};
export const WeeklyAddpostFailedFailureReason = {
    NO_ACTIVE_AUTOPILOT: 'no_active_autopilot',
    GENERATION_ERROR: 'generation_error',
    TIMEOUT: 'timeout',
    UNKNOWN: 'unknown',
};
export const WeeklyConnectPromptShownTrigger = {
    HEADER_CTA: 'header_cta',
};
export const WeeklyConnectPromptShownPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const WeeklyConnectPromptConnectedTrigger = {
    HEADER_CTA: 'header_cta',
};
export const WeeklyConnectPromptConnectedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const WeeklyConnectPromptDismissedTrigger = {
    HEADER_CTA: 'header_cta',
};
export const WeeklyConnectPromptDismissedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const WeeklyDaySelectedSource = {
    INITIAL: 'initial',
    TAP: 'tap',
    KEYBOARD: 'keyboard',
};
export const LoginStartedMethod = {
    EMAIL: 'email',
    GOOGLE: 'google',
    SSO: 'sso',
};
export const LoginCompletedMethod = {
    EMAIL: 'email',
    GOOGLE: 'google',
    SSO: 'sso',
};
export const LoginFailedMethod = {
    EMAIL: 'email',
    GOOGLE: 'google',
    SSO: 'sso',
};
export const RefreshTokenReuseDetectedDeviceType = {
    _DESKTOP: 'Desktop',
    _MOBILE: 'Mobile',
    _TABLET: 'Tablet',
};
export const RefreshTokenReuseDetectedReuseKind = {
    STALE_TOKEN: 'stale_token',
    REVOKED_FAMILY: 'revoked_family',
};
export const RefreshTokenReuseDetectedMode = {
    LOG_ONLY: 'log_only',
    ENFORCE: 'enforce',
};
export const RefreshTokenReuseDetectedPresentedVia = {
    COOKIE: 'cookie',
    BODY: 'body',
};
export const ChatCreatedChatType = {
    _PERSONAL: 'Personal',
    _GROUP: 'Group',
    _PREVIEW: 'Preview',
    _BUILDER_CHAT: 'BuilderChat',
};
export const ChatCreatedSource = {
    CHAT_LIST: 'chat_list',
    NEW_CHAT_BUTTON: 'new_chat_button',
    INVITE_LINK: 'invite_link',
};
export const ChatOpenedChatType = {
    _PERSONAL: 'Personal',
    _GROUP: 'Group',
    _PREVIEW: 'Preview',
    _BUILDER_CHAT: 'BuilderChat',
};
export const ChatOpenedSource = {
    CHAT_LIST: 'chat_list',
    NOTIFICATION: 'notification',
    DIRECT_LINK: 'direct_link',
    SEARCH: 'search',
    TAKA_PROFILE: 'taka_profile',
};
export const ChatLeftChatType = {
    _PERSONAL: 'Personal',
    _GROUP: 'Group',
    _PREVIEW: 'Preview',
    _BUILDER_CHAT: 'BuilderChat',
};
export const MessageSentChatType = {
    _PERSONAL: 'Personal',
    _GROUP: 'Group',
    _PREVIEW: 'Preview',
    _BUILDER_CHAT: 'BuilderChat',
};
export const MessageSentMessageType = {
    _USER: 'User',
    _AGENT: 'Agent',
    _SYSTEM: 'System',
    _TASK: 'Task',
    _HIDDEN: 'Hidden',
};
export const MessageSentSource = {
    CHAT_LAUNCHER: 'chat_launcher',
    CHAT_INPUT: 'chat_input',
    AGENT_BUILDER: 'agent_builder',
    QUICK_REPLY: 'quick_reply',
    DOC_PANEL: 'doc_panel',
};
export const MessageReceivedChatType = {
    _PERSONAL: 'Personal',
    _GROUP: 'Group',
    _PREVIEW: 'Preview',
    _BUILDER_CHAT: 'BuilderChat',
};
export const MessageReceivedMessageType = {
    _USER: 'User',
    _AGENT: 'Agent',
    _SYSTEM: 'System',
    _TASK: 'Task',
    _HIDDEN: 'Hidden',
};
export const AgentMessageSentMessageType = {
    _USER: 'User',
    _AGENT: 'Agent',
    _SYSTEM: 'System',
    _TASK: 'Task',
    _HIDDEN: 'Hidden',
};
export const AgentMessageSentChatType = {
    _PERSONAL: 'Personal',
    _GROUP: 'Group',
    _PREVIEW: 'Preview',
    _BUILDER_CHAT: 'BuilderChat',
};
export const AgentMessageReceivedMessageType = {
    _USER: 'User',
    _AGENT: 'Agent',
    _SYSTEM: 'System',
    _TASK: 'Task',
    _HIDDEN: 'Hidden',
};
export const AgentMessageReceivedChatType = {
    _PERSONAL: 'Personal',
    _GROUP: 'Group',
    _PREVIEW: 'Preview',
    _BUILDER_CHAT: 'BuilderChat',
};
export const ReplyToMessageSelectedChatType = {
    _PERSONAL: 'Personal',
    _GROUP: 'Group',
    _PREVIEW: 'Preview',
    _BUILDER_CHAT: 'BuilderChat',
};
export const ChatInputSuggestionTappedSource = {
    CHAT_LAUNCHER: 'chat_launcher',
    CHAT_INPUT: 'chat_input',
};
export const ChatInfoTappedChatType = {
    _PERSONAL: 'Personal',
    _GROUP: 'Group',
    _PREVIEW: 'Preview',
    _BUILDER_CHAT: 'BuilderChat',
};
export const InviteToChatTappedSource = {
    CHAT_INFO: 'chat_info',
    CHAT_BANNER: 'chat_banner',
};
export const ChatListChatTappedChatType = {
    _PERSONAL: 'Personal',
    _GROUP: 'Group',
    _PREVIEW: 'Preview',
    _BUILDER_CHAT: 'BuilderChat',
};
export const ConnectorSeenProvider = {
    GOOGLE: 'google',
    MONDAY: 'monday',
    MICROSOFT: 'microsoft',
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
};
export const ConnectorTappedProvider = {
    GOOGLE: 'google',
    MONDAY: 'monday',
    MICROSOFT: 'microsoft',
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
};
export const ConnectorTappedSource = {
    CHAT: 'chat',
    SETTINGS: 'settings',
    COMPOSER: 'composer',
};
export const IntegrationConnectSuccessProvider = {
    GOOGLE: 'google',
    MONDAY: 'monday',
    MICROSOFT: 'microsoft',
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
};
export const IntegrationConnectSuccessPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
    GOOGLE: 'google',
    MONDAY: 'monday',
    MICROSOFT: 'microsoft',
};
export const IntegrationConnectSuccessSource = {
    CHAT: 'chat',
    SETTINGS: 'settings',
    COMPOSER: 'composer',
    INTEGRATIONS_PAGE: 'integrations_page',
};
export const IntegrationConnectFailedProvider = {
    GOOGLE: 'google',
    MONDAY: 'monday',
    MICROSOFT: 'microsoft',
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
};
export const IntegrationConnectFailedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
    GOOGLE: 'google',
    MONDAY: 'monday',
    MICROSOFT: 'microsoft',
};
export const IntegrationConnectFailedSource = {
    CHAT: 'chat',
    SETTINGS: 'settings',
    COMPOSER: 'composer',
    INTEGRATIONS_PAGE: 'integrations_page',
};
export const IntegrationConnectFailedErrorType = {
    POPUP: 'popup',
    VERIFICATION: 'verification',
    NETWORK: 'network',
    PROVIDER_CONFIG: 'provider_config',
    UNKNOWN: 'unknown',
};
export const ConnectorRevokeTappedProvider = {
    GOOGLE: 'google',
    MONDAY: 'monday',
    MICROSOFT: 'microsoft',
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
};
export const ConnectorRevokeSuccessProvider = {
    GOOGLE: 'google',
    MONDAY: 'monday',
    MICROSOFT: 'microsoft',
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
};
export const ConnectorRevokeFailedProvider = {
    GOOGLE: 'google',
    MONDAY: 'monday',
    MICROSOFT: 'microsoft',
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
};
export const TaskTappedSource = {
    CHAT: 'chat',
};
export const CspViolationReportedDisposition = {
    REPORT: 'report',
    ENFORCE: 'enforce',
};
export const CspViolationReportedReportFormat = {
    REPORT_TO: 'report-to',
    REPORT_URI: 'report-uri',
};
export const CspViolationReportedPlatform = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
};
export const OnboardingCompletedSource = {
    WEB: 'web',
    CLI: 'cli',
};
export const OnboardingPhaseViewedPhase = {
    WELCOME: 'welcome',
    SCANNING: 'scanning',
    BRAND_CARD: 'brand_card',
    GOALS: 'goals',
    VISUALS: 'visuals',
};
export const OnboardingBrandCardSubmittedFieldsEdited = {
    BUSINESS_NAME: 'businessName',
    INDUSTRY: 'industry',
    DESCRIPTION: 'description',
    TARGET_AUDIENCE: 'targetAudience',
    TONES: 'tones',
    LOGO_URL: 'logoUrl',
    COLORS: 'colors',
};
export const OnboardingPresenceSubmittedAction = {
    CONTINUE: 'continue',
    SKIP: 'skip',
};
export const OnboardingPresenceSubmittedInstagramSource = {
    MANUAL: 'manual',
    AUTOFILLED: 'autofilled',
    EMPTY: 'empty',
};
export const OnboardingPresenceSubmittedFacebookSource = {
    MANUAL: 'manual',
    AUTOFILLED: 'autofilled',
    EMPTY: 'empty',
};
export const OnboardingPresenceSubmittedLinkedinSource = {
    MANUAL: 'manual',
    AUTOFILLED: 'autofilled',
    EMPTY: 'empty',
};
export const OnboardingPresenceSubmittedTiktokSource = {
    MANUAL: 'manual',
    AUTOFILLED: 'autofilled',
    EMPTY: 'empty',
};
export const OnboardingPresenceSubmittedPinterestSource = {
    MANUAL: 'manual',
    AUTOFILLED: 'autofilled',
    EMPTY: 'empty',
};
export const OnboardingVisualsSubmittedContentFocus = {
    PRODUCTS: 'products',
    PEOPLE: 'people',
    OTHER: 'other',
};
export const OnboardingStepWebsiteUrlSkippedMethod = {
    SKIP_BUTTON: 'skip_button',
    CONTINUE_EMPTY: 'continue_empty',
};
export const OnboardingStepInstagramConnectSubmittedConnectionMethod = {
    OAUTH: 'oauth',
    MANUAL: 'manual',
};
export const OnboardingStepUseCaseSelectedUseCase = {
    PERSONAL: 'personal',
    WORK: 'work',
    COLLABORATION: 'collaboration',
    CUSTOM: 'custom',
};
export const AgentTemplateInfoViewedSource = {
    STORE: 'store',
    ONBOARDING: 'onboarding',
};
export const BusinessCreateRequestedFlow = {
    FIRST_BUSINESS: 'first_business',
    ADDITIONAL_BUSINESS: 'additional_business',
};
export const BusinessCreateSucceededFlow = {
    FIRST_BUSINESS: 'first_business',
    ADDITIONAL_BUSINESS: 'additional_business',
};
export const BusinessCreateFailedFlow = {
    FIRST_BUSINESS: 'first_business',
    ADDITIONAL_BUSINESS: 'additional_business',
};
export const AvatarUpdatedAvatarAction = {
    ADDED: 'added',
    UPDATED: 'updated',
    REMOVED: 'removed',
};
export const AccountDeletedActor = {
    SELF: 'self',
    ADMIN: 'admin',
};
export const PaywallViewedSurface = {
    ONBOARDING: 'onboarding',
    IN_APP: 'in_app',
};
export const PaywallViewedSource = {
    ONBOARDING: 'onboarding',
    BILLING_PAGE: 'billing_page',
    FEATURE_GATE: 'feature_gate',
    LIMIT_REACHED: 'limit_reached',
    SETTINGS: 'settings',
    CTA: 'cta',
    DEEPLINK: 'deeplink',
    WELCOME_SCREEN: 'welcome_screen',
    CHAT_HEADER: 'chat_header',
    MESSAGE_ACTION: 'message_action',
    SUBSCRIPTION_GATE: 'subscription_gate',
    SEND_MESSAGE: 'send_message',
    DOWNLOAD: 'download',
    PUBLISH_INSTAGRAM: 'publish_instagram',
    PUBLISH_FACEBOOK: 'publish_facebook',
    PUBLISH_TIKTOK: 'publish_tiktok',
    CREATE_CREATIVE: 'create_creative',
    DUPLICATE_CREATIVE: 'duplicate_creative',
};
export const PaywallViewedScreen = {
    TRIAL_INFO: 'trial-info',
    PLAN_PICKER: 'plan-picker',
};
export const PaywallDismissedSurface = {
    ONBOARDING: 'onboarding',
    IN_APP: 'in_app',
};
export const PaywallSkippedSurface = {
    ONBOARDING: 'onboarding',
    IN_APP: 'in_app',
};
export const TrialTimelineViewedSurface = {
    ONBOARDING: 'onboarding',
    IN_APP: 'in_app',
};
export const PaywallInfoCtaClickedSurface = {
    ONBOARDING: 'onboarding',
    IN_APP: 'in_app',
};
export const TrialCheckoutCtaClickedSurface = {
    ONBOARDING: 'onboarding',
    IN_APP: 'in_app',
};
export const PaywallUpgradeCtaClickedSurface = {
    ONBOARDING: 'onboarding',
    IN_APP: 'in_app',
};
export const PaywallUpgradeCtaClickedPlanName = {
    _PRO: 'Pro',
    _BUSINESS: 'Business',
};
export const PaywallUpgradeCtaClickedBillingPeriod = {
    MONTHLY: 'monthly',
    YEARLY: 'yearly',
};
export const CheckoutStartedSurface = {
    ONBOARDING: 'onboarding',
    IN_APP: 'in_app',
};
export const CheckoutStartedPlanName = {
    _PRO: 'Pro',
    _BUSINESS: 'Business',
};
export const CheckoutStartedBillingPeriod = {
    MONTHLY: 'monthly',
    YEARLY: 'yearly',
};
export const CheckoutStartedReason = {
    TESTER_GRANT: 'tester_grant',
    PROMO_CODE: 'promo_code',
};
export const CheckoutCompletedSurface = {
    ONBOARDING: 'onboarding',
    IN_APP: 'in_app',
};
export const CheckoutCompletedPlanName = {
    _PRO: 'Pro',
    _BUSINESS: 'Business',
};
export const CheckoutCompletedBillingPeriod = {
    MONTHLY: 'monthly',
    YEARLY: 'yearly',
};
export const CheckoutCompletedReason = {
    TESTER_GRANT: 'tester_grant',
    PROMO_CODE: 'promo_code',
};
export const PromoCodeRedeemedSurface = {
    ONBOARDING: 'onboarding',
    IN_APP: 'in_app',
};
export const PromoCodeRedeemedTier = {
    _PRO: 'Pro',
    _BUSINESS: 'Business',
};
export const PromoCodeAppliedSurface = {
    ONBOARDING: 'onboarding',
    IN_APP: 'in_app',
};
export const PromoCodeRemovedSurface = {
    ONBOARDING: 'onboarding',
    IN_APP: 'in_app',
};
export const PromoCodeFailedSurface = {
    ONBOARDING: 'onboarding',
    IN_APP: 'in_app',
};
export const PromoCodeFailedErrorReason = {
    NOT_FOUND: 'not_found',
    DISABLED: 'disabled',
    EXPIRED: 'expired',
    EXHAUSTED: 'exhausted',
    ALREADY_REDEEMED: 'already_redeemed',
    OFFERING_NOT_FOUND: 'offering_not_found',
    INVALID_FORMAT: 'invalid_format',
    NETWORK: 'network',
};
export const CheckoutFailedSurface = {
    ONBOARDING: 'onboarding',
    IN_APP: 'in_app',
};
export const CheckoutFailedPlanName = {
    _PRO: 'Pro',
    _BUSINESS: 'Business',
};
export const CheckoutFailedBillingPeriod = {
    MONTHLY: 'monthly',
    YEARLY: 'yearly',
};
export const TryProPageViewedSource = {
    ONBOARDING: 'onboarding',
    FEATURE_GATE: 'feature_gate',
    LIMIT_REACHED: 'limit_reached',
    SETTINGS: 'settings',
    CTA: 'cta',
    DEEPLINK: 'deeplink',
};
export const TryProDismissedSource = {
    ONBOARDING: 'onboarding',
    FEATURE_GATE: 'feature_gate',
    LIMIT_REACHED: 'limit_reached',
    SETTINGS: 'settings',
    CTA: 'cta',
    DEEPLINK: 'deeplink',
};
export const SocialPublishTappedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialPublishTappedContentType = {
    IMAGE: 'image',
    VIDEO: 'video',
    CAROUSEL: 'carousel',
    STORY: 'story',
    REEL: 'reel',
    PIN: 'pin',
};
export const SocialPublishTappedShape = {
    STATIC_IMAGE: 'static_image',
    SHORT_VERTICAL_VIDEO: 'short_vertical_video',
    STORY: 'story',
    CAROUSEL: 'carousel',
    LONG_FORM_VIDEO: 'long_form_video',
};
export const SocialPublishTappedSource = {
    COMPOSER: 'composer',
    CREATIVE_CARD: 'creative_card',
    CALENDAR: 'calendar',
    HOME: 'home',
    ASSISTANT_CHAT: 'assistant_chat',
};
export const SocialPublishTriggeredPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialPublishTriggeredMediaType = {
    IMAGE: 'image',
    VIDEO: 'video',
    REEL: 'reel',
    CAROUSEL: 'carousel',
    TEXT: 'text',
    SHORT: 'short',
};
export const SocialPublishTriggeredShape = {
    STATIC_IMAGE: 'static_image',
    SHORT_VERTICAL_VIDEO: 'short_vertical_video',
    STORY: 'story',
    CAROUSEL: 'carousel',
    LONG_FORM_VIDEO: 'long_form_video',
};
export const SocialPublishTriggeredTargetType = {
    PERSON: 'person',
    ORGANIZATION: 'organization',
    PAGE: 'page',
    PROFILE: 'profile',
    BOARD: 'board',
    CHANNEL: 'channel',
};
export const SocialPublishTriggeredSource = {
    COMPOSER: 'composer',
    CREATIVE_CARD: 'creative_card',
    CALENDAR: 'calendar',
    HOME: 'home',
    ASSISTANT_CHAT: 'assistant_chat',
    ERROR_RETRY: 'error_retry',
};
export const SocialPublishTriggeredSocialGateway = {
    DIRECT: 'direct',
    PHYLLO: 'phyllo',
    COMPOSIO: 'composio',
};
export const SocialPublishSuccessPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialPublishSuccessMediaType = {
    IMAGE: 'image',
    VIDEO: 'video',
    REEL: 'reel',
    CAROUSEL: 'carousel',
    TEXT: 'text',
    SHORT: 'short',
};
export const SocialPublishSuccessShape = {
    STATIC_IMAGE: 'static_image',
    SHORT_VERTICAL_VIDEO: 'short_vertical_video',
    STORY: 'story',
    CAROUSEL: 'carousel',
    LONG_FORM_VIDEO: 'long_form_video',
};
export const SocialPublishSuccessTargetType = {
    PERSON: 'person',
    ORGANIZATION: 'organization',
    PAGE: 'page',
    PROFILE: 'profile',
    BOARD: 'board',
    CHANNEL: 'channel',
};
export const SocialPublishSuccessSource = {
    COMPOSER: 'composer',
    CREATIVE_CARD: 'creative_card',
    CALENDAR: 'calendar',
    HOME: 'home',
    ASSISTANT_CHAT: 'assistant_chat',
    ERROR_RETRY: 'error_retry',
};
export const SocialPublishSuccessSocialGateway = {
    DIRECT: 'direct',
    PHYLLO: 'phyllo',
    COMPOSIO: 'composio',
};
export const SocialPublishFailedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialPublishFailedFailureReason = {
    TOKEN_EXPIRED: 'token_expired',
    TOKEN_INVALID: 'token_invalid',
    MISSING_PERMISSIONS: 'missing_permissions',
    MEDIA_ERROR: 'media_error',
    IMAGE_ERROR: 'image_error',
    VIDEO_ERROR: 'video_error',
    QUOTA_EXCEEDED: 'quota_exceeded',
    OFF_FACEBOOK_ACTIVITY: 'off_facebook_activity',
    PERSONAL_ACCOUNT: 'personal_account',
    API_ERROR: 'api_error',
    CLIENT_FETCH_FAILED: 'client_fetch_failed',
    GRAPH_API_UNREACHABLE: 'graph_api_unreachable',
    UNKNOWN: 'unknown',
};
export const SocialPublishFailedMediaType = {
    IMAGE: 'image',
    VIDEO: 'video',
    REEL: 'reel',
    CAROUSEL: 'carousel',
    TEXT: 'text',
    SHORT: 'short',
};
export const SocialPublishFailedTargetType = {
    PERSON: 'person',
    ORGANIZATION: 'organization',
    PAGE: 'page',
    PROFILE: 'profile',
    BOARD: 'board',
    CHANNEL: 'channel',
};
export const SocialPublishFailedShape = {
    STATIC_IMAGE: 'static_image',
    SHORT_VERTICAL_VIDEO: 'short_vertical_video',
    STORY: 'story',
    CAROUSEL: 'carousel',
    LONG_FORM_VIDEO: 'long_form_video',
};
export const SocialPublishFailedSource = {
    COMPOSER: 'composer',
    CREATIVE_CARD: 'creative_card',
    CALENDAR: 'calendar',
    HOME: 'home',
    ASSISTANT_CHAT: 'assistant_chat',
    ERROR_RETRY: 'error_retry',
};
export const SocialPublishFailedSocialGateway = {
    DIRECT: 'direct',
    PHYLLO: 'phyllo',
    COMPOSIO: 'composio',
};
export const SocialConnectDialogViewedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialConnectDialogViewedSource = {
    COMPOSER: 'composer',
    CREATIVE_CARD: 'creative_card',
    CALENDAR: 'calendar',
    HOME: 'home',
    ASSISTANT_CHAT: 'assistant_chat',
};
export const SocialConnectDialogDismissedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialConnectDialogDismissedSource = {
    COMPOSER: 'composer',
    CREATIVE_CARD: 'creative_card',
    CALENDAR: 'calendar',
    HOME: 'home',
    ASSISTANT_CHAT: 'assistant_chat',
};
export const SocialComingSoonViewedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialComingSoonViewedSource = {
    COMPOSER: 'composer',
    CREATIVE_CARD: 'creative_card',
    CALENDAR: 'calendar',
    HOME: 'home',
    ASSISTANT_CHAT: 'assistant_chat',
};
export const SocialConnectInitiatedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialConnectInitiatedSocialGateway = {
    DIRECT: 'direct',
    PHYLLO: 'phyllo',
    COMPOSIO: 'composio',
};
export const SocialConnectInitiatedSource = {
    ONBOARDING: 'onboarding',
    COMPOSER: 'composer',
    SETTINGS: 'settings',
    POST_MODAL: 'post_modal',
    CREATIVE_CARD: 'creative_card',
    AUTOPILOT: 'autopilot',
    INTEGRATIONS_PAGE: 'integrations_page',
    COMMENT_AUTOMATION: 'comment_automation',
};
export const SocialConnectSucceededPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialConnectSucceededSocialGateway = {
    DIRECT: 'direct',
    PHYLLO: 'phyllo',
    COMPOSIO: 'composio',
};
export const SocialConnectSucceededSelectedPageSource = {
    MANAGED: 'managed',
    PERSONAL: 'personal',
};
export const SocialConnectFailedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialConnectFailedSocialGateway = {
    DIRECT: 'direct',
    PHYLLO: 'phyllo',
    COMPOSIO: 'composio',
    UNKNOWN: 'unknown',
};
export const SocialConnectFailedStep = {
    TOKEN_EXCHANGE: 'token_exchange',
    CONNECT_INTEGRATION: 'connect_integration',
    STATE_VALIDATION: 'state_validation',
    AUTO_PAGE_SELECT: 'auto_page_select',
    PERSONAL_ACCOUNT_REJECTED: 'personal_account_rejected',
    PROVIDER_ERROR: 'provider_error',
    MISSING_PARAMS: 'missing_params',
    CONNECT_SESSION: 'connect_session',
    SDK_LINK: 'sdk_link',
    LIST_PAGES: 'list_pages',
    SELECT_PAGE: 'select_page',
};
export const SocialConnectFailedFailureClass = {
    USER_ABORTED: 'user_aborted',
    PROVIDER_ERROR: 'provider_error',
    CONFIG_ERROR: 'config_error',
    TOKEN_ERROR: 'token_error',
    NETWORK_ERROR: 'network_error',
    NO_PAGES: 'no_pages',
    UNKNOWN: 'unknown',
};
export const SocialOauthInitiatedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialOauthInitiatedSource = {
    ONBOARDING: 'onboarding',
    COMPOSER: 'composer',
    SETTINGS: 'settings',
    POST_MODAL: 'post_modal',
    CREATIVE_CARD: 'creative_card',
    AUTOPILOT: 'autopilot',
    INTEGRATIONS_PAGE: 'integrations_page',
    COMMENT_AUTOMATION: 'comment_automation',
};
export const SocialOauthInitiatedBlockedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialOauthInitiatedBlockedSource = {
    ONBOARDING: 'onboarding',
    COMPOSER: 'composer',
    SETTINGS: 'settings',
    POST_MODAL: 'post_modal',
    CREATIVE_CARD: 'creative_card',
    AUTOPILOT: 'autopilot',
    INTEGRATIONS_PAGE: 'integrations_page',
    COMMENT_AUTOMATION: 'comment_automation',
};
export const SocialOauthPopupClosedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialOauthPopupClosedSource = {
    ONBOARDING: 'onboarding',
    COMPOSER: 'composer',
    SETTINGS: 'settings',
    POST_MODAL: 'post_modal',
    CREATIVE_CARD: 'creative_card',
    AUTOPILOT: 'autopilot',
    INTEGRATIONS_PAGE: 'integrations_page',
    COMMENT_AUTOMATION: 'comment_automation',
};
export const SocialOauthCallbackSuccessPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialOauthCallbackSuccessAccountType = {
    _P_E_R_S_O_N_A_L: 'PERSONAL',
    _B_U_S_I_N_E_S_S: 'BUSINESS',
    _M_E_D_I_A__C_R_E_A_T_O_R: 'MEDIA_CREATOR',
};
export const SocialOauthCallbackFailedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialOauthCallbackFailedStep = {
    TOKEN_EXCHANGE: 'token_exchange',
    CONNECT_INTEGRATION: 'connect_integration',
    STATE_VALIDATION: 'state_validation',
    AUTO_PAGE_SELECT: 'auto_page_select',
    PERSONAL_ACCOUNT_REJECTED: 'personal_account_rejected',
    PROVIDER_ERROR: 'provider_error',
    MISSING_PARAMS: 'missing_params',
};
export const SocialOauthAccountConfirmedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialOauthAccountSwitchRequestedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialTokenRefreshedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialTokenRefreshFailedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialOauthCallbackReceivedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialOauthCallbackReceivedSocialGateway = {
    DIRECT: 'direct',
};
export const SocialTargetsListedPlatform = {
    FACEBOOK: 'facebook',
};
export const SocialTargetsListedSocialGateway = {
    DIRECT: 'direct',
};
export const SocialTargetSelectedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const SocialTargetSelectedTargetType = {
    PERSON: 'person',
    ORGANIZATION: 'organization',
    PAGE: 'page',
    PROFILE: 'profile',
    BOARD: 'board',
    CHANNEL: 'channel',
};
export const SocialTargetSelectedPageSource = {
    MANAGED: 'managed',
    PERSONAL: 'personal',
};
export const FallbackConnectStartedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const FallbackConnectStartedProvider = {
    PHYLLO: 'phyllo',
    COMPOSIO: 'composio',
};
export const FallbackConnectSucceededPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const FallbackConnectSucceededProvider = {
    PHYLLO: 'phyllo',
    COMPOSIO: 'composio',
};
export const FallbackConnectSucceededSelectedPageSource = {
    MANAGED: 'managed',
    PERSONAL: 'personal',
};
export const FallbackConnectFailedPlatform = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    LINKEDIN_ORG: 'linkedin_org',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
};
export const FallbackConnectFailedProvider = {
    PHYLLO: 'phyllo',
    COMPOSIO: 'composio',
};
export const FallbackConnectFailedStep = {
    CONNECT_SESSION: 'connect_session',
    SDK_LINK: 'sdk_link',
    LIST_PAGES: 'list_pages',
    SELECT_PAGE: 'select_page',
};
export const YoutubeCreativeCreatedSource = {
    HOME: 'home',
    CREATIVES_PAGE: 'creatives_page',
};
export const HomeViewedPlatform = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
};
export const HomeSuggestionScrolledCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const HomeSuggestionTappedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const HomeSuggestionGenerationStartedSource = {
    INITIAL: 'initial',
    REGENERATE: 'regenerate',
};
export const HomeSuggestionGenerationCompletedSource = {
    INITIAL: 'initial',
    REGENERATE: 'regenerate',
};
export const HomeSuggestionGeneratedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const HomeSuggestionGeneratedStatus = {
    READY: 'ready',
    FAILED: 'failed',
    ERROR: 'error',
};
export const HomeSuggestionGeneratedLens = {
    AUDIENCE_PULSE: 'audience_pulse',
    CULTURAL_PULSE: 'cultural_pulse',
    BRAND_STORY: 'brand_story',
};
export const HomeSuggestionRegenerateTappedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const HomePostModalOpenedEntrySource = {
    IDEA_CARD: 'idea_card',
    CALENDAR_ENTRY: 'calendar_entry',
    COMPOSER: 'composer',
    COCKPIT: 'cockpit',
    POST_ARRIVAL: 'post_arrival',
};
export const TopicGenerateMoreMode = {
    SURPRISE: 'surprise',
    DIRECTION: 'direction',
};
export const HomeTopicSwitcherOpenedSource = {
    INLINE: 'inline',
    MOBILE_SHEET: 'mobile_sheet',
};
export const HomeTopicSwitcherClosedSource = {
    INLINE: 'inline',
    MOBILE_SHEET: 'mobile_sheet',
};
export const HomeIdeaCardTappedStatus = {
    SUGGESTED: 'suggested',
    CONFIRMED: 'confirmed',
    PUBLISHING: 'publishing',
    LIVE: 'live',
    SCHEDULED: 'scheduled',
    DISCARDED: 'discarded',
};
export const HomeIdeaCardEditTappedStatus = {
    SUGGESTED: 'suggested',
    CONFIRMED: 'confirmed',
    PUBLISHING: 'publishing',
    LIVE: 'live',
    SCHEDULED: 'scheduled',
    DISCARDED: 'discarded',
};
export const HomeIdeaCardRegenerateTappedSource = {
    HOME: 'home',
    POSTS: 'posts',
    AUTO_RETRY_ON_LOAD: 'auto_retry_on_load',
    POST_ARRIVAL: 'post_arrival',
};
export const HomePostModalClosedEntrySource = {
    IDEA_CARD: 'idea_card',
    CALENDAR_ENTRY: 'calendar_entry',
    COMPOSER: 'composer',
    COCKPIT: 'cockpit',
    POST_ARRIVAL: 'post_arrival',
};
export const HomePostModalModeSwitchedMode = {
    NOW: 'now',
    SCHEDULE: 'schedule',
};
export const HomeChatBarTappedSource = {
    MOBILE_BAR: 'mobile_bar',
    FAB: 'fab',
};
export const HomeTopicGenerationStartedMode = {
    INITIAL: 'initial',
    SURPRISE: 'surprise',
    DIRECTION: 'direction',
};
export const HomeTopicGenerationCompletedMode = {
    INITIAL: 'initial',
    SURPRISE: 'surprise',
    DIRECTION: 'direction',
};
export const HomeTopicGenerationFailedMode = {
    INITIAL: 'initial',
    SURPRISE: 'surprise',
    DIRECTION: 'direction',
};
export const HomePostGenerationStartedSource = {
    PICK: 'pick',
    GENERATE_MORE: 'generate_more',
    REGENERATE: 'regenerate',
    AUTOPILOT: 'autopilot',
    INTENT: 'intent',
};
export const HomePostGenerationStartedIntentSource = {
    HERO_PROMPT: 'hero_prompt',
    CHIP: 'chip',
    INGREDIENTS: 'ingredients',
    STREAM: 'stream',
};
export const HomePostGenerationCompletedSource = {
    PICK: 'pick',
    GENERATE_MORE: 'generate_more',
    REGENERATE: 'regenerate',
    AUTOPILOT: 'autopilot',
    INTENT: 'intent',
};
export const HomePostGenerationFailedSource = {
    PICK: 'pick',
    GENERATE_MORE: 'generate_more',
    REGENERATE: 'regenerate',
    AUTOPILOT: 'autopilot',
    INTENT: 'intent',
};
export const HomeCreationIntentSubmittedSource = {
    HERO_PROMPT: 'hero_prompt',
    CHIP: 'chip',
    INGREDIENTS: 'ingredients',
    STREAM: 'stream',
};
export const HomeCreationIntentCreatedSource = {
    HERO_PROMPT: 'hero_prompt',
    CHIP: 'chip',
    INGREDIENTS: 'ingredients',
    STREAM: 'stream',
};
export const HomeCreationIntentFailedSource = {
    HERO_PROMPT: 'hero_prompt',
    CHIP: 'chip',
    INGREDIENTS: 'ingredients',
    STREAM: 'stream',
};
export const HomeAttentionStripCtaTappedKind = {
    APPROVALS: 'approvals',
};
export const ComposerViewedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const ComposerViewedSource = {
    PROMPT: 'prompt',
    AUTOPILOT: 'autopilot',
    ASSISTANT: 'assistant',
    CREATIVES_LIBRARY: 'creatives_library',
    POST_MODAL: 'post_modal',
    SUGGESTION: 'suggestion',
    HOME_GRID: 'home_grid',
    DIRECT_URL: 'direct_url',
    POSTS_PAGE: 'posts_page',
};
export const ComposerMessageSentCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const ComposerMessageReceivedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const ComposerContentGeneratedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const ComposerDuplicateTappedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const ComposerDeleteTappedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const ComposerDownloadTappedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const ComposerDownloadTappedFormat = {
    PNG: 'png',
    PDF: 'pdf',
    HTML: 'html',
    IMAGE: 'image',
};
export const ComposerPreviewImageDownloadedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const ComposerPreviewContentCopiedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const ComposerPreviewContentCopiedField = {
    CAPTION: 'caption',
    HASHTAGS: 'hashtags',
    MESSAGE: 'message',
};
export const ComposerPreviewChangeRequestedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const ComposerPreviewChangeRequestedField = {
    IMAGE: 'image',
    CAPTION: 'caption',
    HASHTAGS: 'hashtags',
    HEADLINE: 'headline',
    SUBTITLE: 'subtitle',
    TAGLINE: 'tagline',
    HERO_IMAGE: 'hero_image',
};
export const ComposerImageUploadedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const ComposerImageUploadedUploadMethod = {
    BUTTON: 'button',
    PASTE: 'paste',
    DRAG: 'drag',
};
export const ComposerVideoUploadStartedUploadMethod = {
    BUTTON: 'button',
    DRAG: 'drag',
    PASTE: 'paste',
};
export const ComposerVideoUploadFailedErrorType = {
    FORMAT: 'format',
    SIZE: 'size',
    DURATION: 'duration',
    ASPECT: 'aspect',
    METADATA: 'metadata',
    NETWORK: 'network',
    SERVER: 'server',
    VALIDATION: 'validation',
    SIZE_LIMIT: 'size_limit',
    UNKNOWN: 'unknown',
};
export const ComposerEmptyResponseCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const ComposerBackTappedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const ComposerScoreExplainerOpenedRubric = {
    STATIC: 'static',
    CAROUSEL: 'carousel',
    VIDEO: 'video',
};
export const BrandKitFieldUpdatedFieldName = {
    BUSINESS_NAME: 'business_name',
    INDUSTRY: 'industry',
    TARGET_AUDIENCE: 'target_audience',
    DESCRIPTION: 'description',
    HEADING_FONT: 'heading_font',
    BODY_FONT: 'body_font',
    WEBSITE: 'website',
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    TWITTER: 'twitter',
    LINKEDIN: 'linkedin',
    PRIMARY_COLOR: 'primary_color',
    SECONDARY_COLOR: 'secondary_color',
    ACCENT_COLOR: 'accent_color',
    TONE_OF_VOICE: 'tone_of_voice',
    LOGO_PRIMARY: 'logo_primary',
    LOGO_ICON: 'logo_icon',
};
export const BrandKitLogoUploadedLogoType = {
    PRIMARY: 'primary',
    ICON: 'icon',
};
export const BrandKitLogoRemovedLogoType = {
    PRIMARY: 'primary',
    ICON: 'icon',
};
export const BrandImageUploadedTag = {
    PRODUCTS: 'products',
    PEOPLE: 'people',
    OTHER: 'other',
};
export const SidebarNavTappedDestination = {
    HOME: 'home',
    AUTOPILOT: 'autopilot',
    CREATIVES: 'creatives',
    BRAND: 'brand',
    INTEGRATIONS: 'integrations',
    COLLABORATORS: 'collaborators',
    BILLING: 'billing',
};
export const CreativeGenerationCardViewedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const CreativeGenerationStatusChangedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const CreativeGenerationStatusChangedNewStatus = {
    READY: 'ready',
    FAILED: 'failed',
};
export const CreativeGenerationCardTappedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const CreativeGenerationCardTappedCardStatus = {
    READY: 'ready',
    CREATED: 'created',
};
export const SocialkitGenerationOutcomeEngineVersion = {
    V1: 'v1',
    V2: 'v2',
};
export const SocialkitGenerationOutcomeCreativeType = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
};
export const SocialkitGenerationOutcomeShape = {
    STATIC: 'static',
    CAROUSEL: 'carousel',
    VIDEO: 'video',
};
export const SocialkitGenerationOutcomeOutcome = {
    OK: 'ok',
    NOT_POSTABLE: 'not_postable',
    INSUFFICIENT_CREDITS: 'insufficient_credits',
    ERROR: 'error',
};
export const SocialkitGenerationOutcomeDesignTier = {
    _G_R_E_A_T: 'GREAT',
    _S_T_R_O_N_G: 'STRONG',
    _C_O_M_P_E_T_E_N_T: 'COMPETENT',
    _T_E_M_P_L_A_T_E: 'TEMPLATE',
};
export const SocialkitGenerationOutcomePhotoSource = {
    REAL: 'real',
    GENERATED: 'generated',
    NONE: 'none',
};
export const PostsPageViewedPlatform = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
};
export const PostsFilterTappedFilter = {
    DRAFT: 'draft',
    SCHEDULED: 'scheduled',
    LIVE: 'live',
};
export const PostScheduledSource = {
    COMPOSER: 'composer',
    POST_MODAL: 'post_modal',
    CALENDAR: 'calendar',
    ASSISTANT_CHAT: 'assistant_chat',
    CREATIVE_CARD: 'creative_card',
    BYO_UPLOAD: 'byo_upload',
};
export const PostScheduledPlatforms = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE_SHORTS: 'youtube_shorts',
};
export const PostScheduledShape = {
    STATIC_IMAGE: 'static_image',
    SHORT_VERTICAL_VIDEO: 'short_vertical_video',
    STORY: 'story',
    CAROUSEL: 'carousel',
    LONG_FORM_VIDEO: 'long_form_video',
};
export const PostScheduledEntrySource = {
    HOME_IDEA_CARD: 'home_idea_card',
    POSTS_DRAFTS: 'posts_drafts',
    CALENDAR_ENTRY: 'calendar_entry',
    CALENDAR_CREATE: 'calendar_create',
    COCKPIT: 'cockpit',
    COMPOSER_DIRECT: 'composer_direct',
    ASSISTANT_CHAT: 'assistant_chat',
    POST_ARRIVAL: 'post_arrival',
    BYO_UPLOAD: 'byo_upload',
};
export const ByoUploadOpenedSource = {
    CALENDAR: 'calendar',
    HOME: 'home',
};
export const ByoPostCreatedSource = {
    CALENDAR: 'calendar',
    HOME: 'home',
};
export const ByoPostCreatedMediaKind = {
    VIDEO: 'video',
    IMAGE: 'image',
    CAROUSEL: 'carousel',
};
export const ByoPostCreatedPlatforms = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin',
    PINTEREST: 'pinterest',
    TIKTOK: 'tiktok',
    YOUTUBE_SHORTS: 'youtube_shorts',
};
export const ByoMediaUpdatedMediaKind = {
    VIDEO: 'video',
    IMAGE: 'image',
    CAROUSEL: 'carousel',
};
export const ByoMediaUpdatedAction = {
    ADD: 'add',
    REMOVE: 'remove',
    REORDER: 'reorder',
    SWAP: 'swap',
};
export const PostApprovedSurface = {
    COCKPIT: 'cockpit',
    CALENDAR: 'calendar',
    COMPOSER: 'composer',
    HOME: 'home',
};
export const PostRescheduledSurface = {
    COCKPIT: 'cockpit',
    CALENDAR: 'calendar',
};
export const PostRescheduledSource = {
    DIALOG: 'dialog',
    DRAG_DROP: 'drag_drop',
    UNDO_SKIP: 'undo_skip',
};
export const PostUnscheduledSurface = {
    COCKPIT: 'cockpit',
    CALENDAR: 'calendar',
    COMPOSER: 'composer',
    SYSTEM_EXPIRED: 'system_expired',
};
export const PostRegeneratedSurface = {
    COCKPIT: 'cockpit',
    CALENDAR: 'calendar',
};
export const PostDeletedSurface = {
    COCKPIT: 'cockpit',
    CALENDAR: 'calendar',
    POSTS_PAGE: 'posts_page',
    COMPOSER: 'composer',
    POST_MODAL: 'post_modal',
};
export const PostDeletedStateBefore = {
    DRAFT: 'draft',
    NEEDS_APPROVAL: 'needs_approval',
    SCHEDULED: 'scheduled',
    PUBLISHED: 'published',
};
export const CreditConsumedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const CreditConsumedConsumedFrom = {
    SUBSCRIPTION: 'subscription',
    TOP_UP: 'topUp',
};
export const CreditsLowTier = {
    _FREE: 'Free',
    _PRO: 'Pro',
    _BUSINESS: 'Business',
};
export const CreditsExhaustedTier = {
    _FREE: 'Free',
    _PRO: 'Pro',
    _BUSINESS: 'Business',
};
export const CreditsExhaustedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const CreditsExhaustedUpgradeTappedTier = {
    _FREE: 'Free',
    _PRO: 'Pro',
    _BUSINESS: 'Business',
};
export const CreditsExhaustedTopupTappedTier = {
    _FREE: 'Free',
    _PRO: 'Pro',
    _BUSINESS: 'Business',
};
export const BillingPageViewedTier = {
    _FREE: 'Free',
    _PRO: 'Pro',
    _BUSINESS: 'Business',
};
export const BillingManageSubscriptionTappedTier = {
    _PRO: 'Pro',
    _BUSINESS: 'Business',
};
export const TopupModalViewedTier = {
    _PRO: 'Pro',
    _BUSINESS: 'Business',
};
export const TopupModalViewedSource = {
    BILLING_PAGE: 'billing_page',
    INSUFFICIENT_CREDITS: 'insufficient_credits',
    OTHER: 'other',
};
export const TopupReferralNudgeClickedSource = {
    BILLING_PAGE: 'billing_page',
    INSUFFICIENT_CREDITS: 'insufficient_credits',
    OTHER: 'other',
};
export const TopupPackSelectedTier = {
    _PRO: 'Pro',
    _BUSINESS: 'Business',
};
export const CalendarViewedView = {
    WEEK: 'week',
    MONTH: 'month',
};
export const CalendarEntryTappedEntryType = {
    AUTOPILOT_SLOT: 'autopilot_slot',
    GENERATED_CREATIVE: 'generated_creative',
    SCHEDULED_CREATIVE: 'scheduled_creative',
    PUBLISHED: 'published',
};
export const CalendarEntryTappedChannel = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    TIKTOK: 'tiktok',
};
export const CalendarViewChangedFromView = {
    WEEK: 'week',
    MONTH: 'month',
};
export const CalendarViewChangedToView = {
    WEEK: 'week',
    MONTH: 'month',
};
export const CalendarDateNavigatedDirection = {
    PREV: 'prev',
    NEXT: 'next',
    TODAY: 'today',
};
export const CalendarAutopilotSetupStartedSource = {
    EMPTY_STATE: 'empty_state',
    DATE_CLICK: 'date_click',
    DETAIL_PANEL: 'detail_panel',
};
export const CalendarPublishNowTappedChannel = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    TIKTOK: 'tiktok',
};
export const CalendarPostGenerationTriggeredChannel = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    TIKTOK: 'tiktok',
    LINKEDIN: 'linkedin',
    YOUTUBE: 'youtube',
};
export const CalendarPostGenerationTriggeredCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
    TIKTOK_VIDEO: 'tiktok_video',
    LINKEDIN_POST: 'linkedin_post',
    YOUTUBE_SHORT: 'youtube_short',
};
export const CalendarPostGenerationCompletedStatus = {
    READY: 'ready',
    FAILED: 'failed',
};
export const CalendarPostGenerationCompletedChannel = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    TIKTOK: 'tiktok',
    LINKEDIN: 'linkedin',
    YOUTUBE: 'youtube',
};
export const CalendarPostGenerationCompletedCreativeType = {
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    LOGO: 'logo',
    TIKTOK: 'tiktok',
    LINKEDIN: 'linkedin',
    YOUTUBE_SHORTS: 'youtube_shorts',
    PINTEREST: 'pinterest',
};
export const CalendarPostGenerationCompletedError = {
    INSUFFICIENT_CREDITS: 'insufficient_credits',
    GENERATION_ERROR: 'generation_error',
    TIMEOUT: 'timeout',
    TRIGGER_FAILED: 'trigger_failed',
    UNKNOWN: 'unknown',
};
export const AssistantChatOpenedPlatform = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
};
export const AssistantChatOpenedSource = {
    FLOATING_BAR_INPUT: 'floating_bar_input',
    FLOATING_BAR_BUTTON: 'floating_bar_button',
    PAGE_LOAD: 'page_load',
    FAB: 'fab',
    CMDK: 'cmdk',
    EVENT: 'event',
};
export const AssistantChatMessageSentSource = {
    TYPED: 'typed',
    QUICK_PROMPT: 'quick_prompt',
};
export const AssistantChatMessageSentPlatform = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
};
export const AssistantChatMessageReceivedCreativeType = {
    INSTAGRAM_POST: 'instagram_post',
    FACEBOOK_POST: 'facebook_post',
};
export const AssistantChatQuickPromptTappedPlatform = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
};
export const CommentAutomationViewedConnectionState = {
    READY: 'ready',
    UPGRADE: 'upgrade',
    NONE: 'none',
};
export const CommentAutomationEditorOpenedMode = {
    CREATE: 'create',
    EDIT: 'edit',
};
export const CommentAutomationSavedMode = {
    CREATE: 'create',
    EDIT: 'edit',
};
export const CommentAutomationSavedAction = {
    REPLY: 'reply',
    REPLY_AND_DM: 'reply_and_dm',
    DM: 'dm',
};
export const CommentAutomationStatusChangedStatus = {
    LIVE: 'live',
    PAUSED: 'paused',
};
export const CommentAutomationExecutedAction = {
    REPLY: 'reply',
    REPLY_AND_DM: 'reply_and_dm',
    DM: 'dm',
};
export const ReferralSharedMethod = {
    COPY_LINK: 'copy_link',
    NATIVE_SHARE: 'native_share',
    EMAIL: 'email',
    FACEBOOK: 'facebook',
    X: 'x',
    LINKEDIN: 'linkedin',
};
export const ReferralSharedSurface = {
    SETTINGS: 'settings',
    POST_PUBLISH_SUCCESS: 'post_publish_success',
    CREDITS_EXHAUSTED: 'credits_exhausted',
};
export const ReferralRewardedSide = {
    REFERRER: 'referrer',
    REFEREE: 'referee',
};
export const ReferralCelebrationViewedRole = {
    REFEREE: 'referee',
    REFERRER: 'referrer',
};
export const ReferralRejectedReason = {
    INVALID_CODE: 'invalid_code',
    SELF_REFERRAL: 'self_referral',
    PROGRAM_DISABLED: 'program_disabled',
    CAP_REACHED: 'cap_reached',
    CLAWED_BACK: 'clawed_back',
};
export const SupportHandoffCreatedReason = {
    HUMAN_REQUESTED: 'human_requested',
    BILLING: 'billing',
    BUG: 'bug',
    OTHER: 'other',
};
export const SupportHandoffCreatedStatus = {
    DELIVERED: 'delivered',
    ALREADY_OPEN: 'already_open',
    FAILED: 'failed',
};
export const SupportHandoffMessengerOpenedStatus = {
    DELIVERED: 'delivered',
    ALREADY_OPEN: 'already_open',
    FAILED: 'failed',
};
export const INTERCOM_EVENT_NAMES = [
    'Autopilot Status Changed',
    'Weekly Session Completed',
    'Login Completed',
    'Integration Connect Success',
    'Integration Connect Failed',
    'Onboarding Started',
    'Onboarding Completed',
    'Onboarding Scrape Completed',
    'Onboarding Step Website URL Submitted',
    'Onboarding Step Website URL Skipped',
    'Business Create Succeeded',
    'Business Create Failed',
    'Paywall Viewed',
    'Paywall Dismissed',
    'Paywall Skipped',
    'Trial Checkout CTA Clicked',
    'Paywall Upgrade CTA Clicked',
    'Checkout Started',
    'Checkout Completed',
    'Promo Code Redeemed',
    'Checkout Failed',
    'Social Publish Success',
    'Social Publish Failed',
    'Social Connect Failed',
    'Home Creation Intent Created',
    'Composer Content Generated',
    'Post Scheduled',
    'BYO Post Created',
    'Post Approved',
    'Credits Low',
    'Billing Page Viewed',
    'Billing Manage Subscription Tapped',
    'Billing Upgrade To Business Tapped',
    'Topup Purchase Completed',
    'Topup Purchase Failed',
    'Comment Automation Saved',
    'Comment Automation Status Changed',
    'Referral Shared',
];
const INTERCOM_EVENT_NAME_SET = new Set(INTERCOM_EVENT_NAMES);
export function isIntercomEvent(eventName) {
    return INTERCOM_EVENT_NAME_SET.has(eventName);
}
export function getCategoryEvents(category) {
    return Object.values(AnalyticsEvents[category]);
}
export function getAllEventNames() {
    return Object.values(AnalyticsEvents).flatMap(category => Object.values(category));
}
export function isValidEventName(eventName) {
    return getAllEventNames().includes(eventName);
}
export const EventMetadata = {
    version: '1.0.0',
    totalEvents: 385,
    categories: [
        "agentBuilder",
        "agents",
        "apps",
        "application",
        "autopilot",
        "authentication",
        "chat",
        "engagement",
        "errors",
        "onboarding",
        "profile",
        "paywall",
        "agentActivation",
        "social",
        "home",
        "composer",
        "brandKit",
        "sidebar",
        "creatives",
        "posts",
        "credits",
        "billing",
        "calendar",
        "assistantChat",
        "commentAutomation",
        "referrals",
        "support"
    ]
};
//# sourceMappingURL=analytics-events.js.map